import * as yup from "yup";
import { DateType } from "utils/types";
import { validateDateRange } from "utils/validations";

export const validationSchema = yup.object({
  date: yup
    .object()
    .test("timeValidation", (value, context) =>
      validateDateRange(value as unknown as DateType, context, 7)
    ),
});
